<template>
  <div class="story">
    <div class="story-left reveal">
      <span class="section-eyebrow">Who We Are</span>
      <h2 class="section-title">
        Built on authenticity.<br />Driven by style.
      </h2>
    </div>
    <div class="story-right">
      <p class="story-p reveal reveal-delay-1">
        <strong>We started our journey in 2020</strong> — right at a time when
        the world was rapidly shifting online. What began as a simple idea
        quickly turned into something much bigger. In our very first year, we
        reached our first 1,000 sales — a milestone that confirmed we were on
        the right path.
      </p>
      <p class="story-p reveal reveal-delay-2">
        Hooligans Eyewear was founded by <strong>David and Neli</strong>, driven
        by a shared passion for fashion and a vision to make premium eyewear
        more accessible. We began by selling on major marketplaces — eBay,
        Poshmark, Mercari, Grailed, and Tradesy — platforms that helped us grow,
        learn, and connect with thousands of customers across the United States.
      </p>
      <p class="story-p reveal reveal-delay-3">
        From the very beginning, we focused on one category we truly love —
        designer eyewear. Sunglasses and optical frames are not just
        accessories; they are a statement of style, personality, and confidence.
        Today, we proudly work only with
        <strong>official and licensed suppliers</strong>, ensuring that every
        item we sell is 100% authentic.
      </p>
      <p class="story-p reveal reveal-delay-3">
        In 2024, we launched our own website with one clear goal: to give our
        customers a better, more flexible shopping experience. Every product you
        see is in stock and ready to ship from our own warehouse.
        <strong>We personally manage our inventory</strong> — no third-party
        fulfillment — to guarantee fast handling, quality control, and
        reliability.
      </p>

      <div class="story-stat-row reveal reveal-delay-4">
        <div v-for="stat in stats" :key="stat.label" class="stat-item">
          <span
            class="stat-num"
            :data-count-target="stat.target"
            :data-suffix="stat.suffix || undefined"
            >{{ stat.display }}</span
          >
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutStory",
  props: {
    stats: {
      type: Array,
      default: () => [
        { target: 2020, display: "2020", label: "Founded" },
        {
          target: 10000,
          suffix: "K+",
          display: "10K+",
          label: "Happy Customers",
        },
        {
          target: 1000,
          suffix: "K+",
          display: "1K+",
          label: "First-Year Sales",
        },
        { target: 100, suffix: "%", display: "100%", label: "Authentic" },
      ],
    },
  },
};
</script>
